(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  function init(root) {
    if (root.dataset.oeReady) return;
    root.dataset.oeReady = '1';

    var $ = function (s) { return root.querySelector(s); };
    var radios      = root.querySelectorAll('.oe-tier__radio');
    var addonBox    = $('[data-oe-addon]');
    var addonPrice  = parseInt(root.dataset.addonPrice, 10) || 0;
    var addonId     = root.dataset.addonId || '';
    var discount    = root.dataset.discount || '';
    var flatShip    = parseInt(root.dataset.shipping, 10) || 0;
    var freeAt      = parseInt(root.dataset.freeShipAt, 10) || 0;

    var el = {
      count:    $('[data-oe-count]'),
      name:     $('[data-oe-name]'),
      compare:  $('[data-oe-compare]'),
      line:     $('[data-oe-line]'),
      subtotal: $('[data-oe-subtotal]'),
      shipping: $('[data-oe-shipping]'),
      saveRow:  $('[data-oe-saverow]'),
      save:     $('[data-oe-save]'),
      total:    $('[data-oe-total]'),
      ctaTotal: $('[data-oe-cta-total]'),
      cta:      $('[data-oe-checkout]')
    };

    function selected() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return null;
    }

    function render() {
      var r = selected();
      if (!r) return;

      var qty      = parseInt(r.dataset.qty, 10) || 1;
      if (qty < 1 || qty > 24) qty = 1;
      var price    = parseInt(r.dataset.price, 10) || 0;
      var compare  = parseInt(r.dataset.compare, 10) || price;
      var wantAddon = !!(addonBox && addonBox.checked && addonId);

      var addonTotal = wantAddon ? addonPrice * qty : 0;
      var subtotal   = price + addonTotal;
      var compareSum = compare + addonTotal;
      var ship       = (freeAt > 0 && subtotal >= freeAt) ? 0 : flatShip;
      var total      = subtotal + ship;
      var saved      = Math.max(0, compareSum - subtotal);

      if (el.count)    el.count.textContent = qty;
      if (el.name)     el.name.textContent = r.dataset.title + (wantAddon ? ' + warranty' : '');
      if (el.compare)  el.compare.hidden = !(compareSum > subtotal);
      if (el.line)     el.line.textContent = money(subtotal);
      if (el.subtotal) el.subtotal.textContent = money(subtotal);
      if (el.total)    el.total.textContent = money(total);
      if (el.ctaTotal) el.ctaTotal.textContent = '— ' + money(total);
      if (el.shipping) el.shipping.textContent = ship === 0 ? 'Free' : money(ship);

      if (el.compare) {
        el.compare.textContent = compareSum > subtotal ? money(compareSum) : '';
      }
      if (el.saveRow && el.save) {
        el.saveRow.hidden = saved <= 0;
        el.save.textContent = '−' + money(saved);
      }
    }

    /* Build a Shopify cart permalink and hand off to native checkout.
       Format: /cart/{variantId}:{qty},{variantId}:{qty}?discount=CODE */
    function checkout() {
      var r = selected();
      if (!r) return;

      var qty = parseInt(r.dataset.qty, 10) || 1;
      if (qty < 1 || qty > 24) qty = 1;
      var items = [r.value + ':1'];

      if (addonBox && addonBox.checked && addonId) {
        items.push(addonId + ':' + qty);
      }

      var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/');
      url = url.replace(/\/$/, '') + '/cart/' + items.join(',');
      if (discount) url += '?discount=' + encodeURIComponent(discount);

      el.cta.setAttribute('aria-busy', 'true');
      window.location.href = url;
    }

    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', render);
    if (addonBox) addonBox.addEventListener('change', render);
    if (el.cta) el.cta.addEventListener('click', checkout);

    render();

    /* Countdown against a fixed end timestamp. Hides itself once past. */
    var timer = root.querySelector('[data-oe-timer]');
    if (timer) {
      var ends = Date.parse(timer.dataset.ends);
      var clock = timer.querySelector('[data-oe-clock]');
      if (!isNaN(ends)) {
        var tick = function () {
          var left = ends - Date.now();
          if (left <= 0) { timer.remove(); return; }
          var s = Math.floor(left / 1000);
          var d = Math.floor(s / 86400);
          var h = Math.floor((s % 86400) / 3600);
          var m = Math.floor((s % 3600) / 60);
          var ss = s % 60;
          var pad = function (n) { return String(n).padStart(2, '0'); };
          clock.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(ss);
          timer.hidden = false;
        };
        tick();
        setInterval(tick, 1000);
      }
    }
  }

  var boot = function () {
    document.querySelectorAll('[data-oe]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
